import { render, staticRenderFns } from "./SudokuBoard.vue?vue&type=template&id=2fd358b8&scoped=true&"
import script from "./SudokuBoard.vue?vue&type=script&lang=ts&"
export * from "./SudokuBoard.vue?vue&type=script&lang=ts&"
import style0 from "./SudokuBoard.vue?vue&type=style&index=0&id=2fd358b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd358b8",
  null
  
)

export default component.exports